import { render, staticRenderFns } from "./base-modal.vue?vue&type=template&id=59a29442&"
import script from "./base-modal.vue?vue&type=script&lang=js&"
export * from "./base-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports